import { Entry } from 'contentful';
import { IRichText } from '@belong/types/ui';
import { FRichText } from '../richText.factory';

interface ICountryListData {
  content: IRichText;
  countries: string[];
  showLink: string;
  hideLink: string;
}

export const FElementCountryList = (data: Entry<any>): ICountryListData => {
  const { countryListCopy, countries, showCountriesLinkLabel, hideCountriesLinkLabel } = data.fields;
  return {
    content: FRichText(countryListCopy),
    countries,
    showLink: showCountriesLinkLabel,
    hideLink: hideCountriesLinkLabel
  };
};
